import context from '@/context'
import { allowErrorDialog } from '@/utils/fetch'
import debug from 'debug'

const log = debug('app:store:background-jobs')

const pageSize = 10

const initialState = {
  jobs: [],
  closing: [],
  allJobs: [],
  page: 0,
  loading: false,
  newestJobTime: null
}

const actionTypes = {
  jobProgressChange: 'backgroundJobs/jobProgressChange',
  newJob: 'backgroundJobs/newJob',
  loadJobsProgress: 'backgroundJobs/initJobsProgress',
  closeJob: 'backgroundJobs/closeJob',
  closingJob: 'backgroundJobs/closingJob',
  closeFailed: 'backgroundJobs/closeFailed',
  loading: 'backgroundJobs/loading',
  loaded: 'backgroundJobs/loaded',
  error: 'backgroundJobs/error'
}

const parseData = (jobs) => {
  jobs.forEach(j => { j.data = JSON.parse(j.data) })
}

export const actionCreators = {
  loadBackgroundJobs: (page) => async (dispatch, _) => {
    dispatch({ type: actionTypes.loading })
    const skip = page * pageSize

    try {
      const jobs = await context.api.backgroundJobService.getBackgroundJobs(skip, pageSize, allowErrorDialog)
      parseData(jobs)
      dispatch({ type: actionTypes.loaded, data: { jobs, page, skip } })
    } catch (error) {
      log('Failed to load background jobs: %o', error)
      dispatch({ type: actionTypes.error, update: { loading: false } })
    }
  },
  jobProgressChanged: (payload) => async (dispatch, getState) => {
    if (payload.data) payload.data = JSON.parse(payload.data)

    let state = getState()
    const index = state.backgroundJobs.jobs.findIndex(x => x.id === payload.id)
    if (index < 0) {
      dispatch({ type: actionTypes.newJob })
    }

    dispatch({ type: actionTypes.jobProgressChange, payload })
  },
  loadJobsProgress: () => {
    return async (dispatch) => {
      try {
        const payload = await context.api.backgroundJobService.getAll()
        parseData(payload)
        dispatch({ type: actionTypes.loadJobsProgress, payload })
      } catch (error) {
        log('Failed to load initial background jobs: %o', error)
      }
    }
  },
  closeJob: (id) => {
    return async (dispatch, getState) => {
      try {
        const isClosing = getState().backgroundJobs.closing.indexOf(id) >= 0
        if (!isClosing) {
          dispatch({ type: actionTypes.closingJob, id })
          await context.api.backgroundJobService.close(id)
          dispatch({ type: actionTypes.closeJob, id })
        }
      } catch (error) {
        dispatch({ type: actionTypes.closeFailed, id })
      }
    }
  }
}

const updateJobs = (state, propName, job) => {
  const index = state[propName].findIndex(x => x.id === job.id)
  if (index >= 0) {
    // updating existing job
    return { ...state, [propName]: state[propName].map((v, i) => i !== index ? v : job) }
  } else {
    // adding new job to array
    return { ...state, [propName]: [job, ...state[propName]] }
  }
}
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.loadJobsProgress: {
      return { ...state, jobs: action.payload }
    }
    case actionTypes.jobProgressChange:
    {
      const newState = updateJobs(state, 'jobs', action.payload)
      return updateJobs(newState, 'allJobs', action.payload)
    }
    case actionTypes.newJob:
    {
      return { ...state, newestJobTime: new Date() }
    }
    case actionTypes.closingJob:
    {
      return { ...state, closing: [...state.closing, action.id] }
    }
    case actionTypes.closeJob:
    {
      return {
        ...state,
        jobs: state.jobs.filter(x => x.id !== action.id),
        closing: state.closing.filter(x => x !== action.id),
        allJobs: state.allJobs.map(x => x.id !== action.id ? x : { ...x, progress: 100, status: 1 })
      }
    }
    case actionTypes.closeFailed:
    {
      return { ...state, closing: state.closing.filter(x => x !== action.id) }
    }
    case actionTypes.loading: return { ...state, loading: true }
    case actionTypes.loaded: {
      const { jobs, page, skip } = action.data
      return {
        ...state,
        allJobs: [ ...state.allJobs.slice(0, skip), ...jobs ],
        page,
        loading: false
      }
    }
    case actionTypes.error: return { ...state, ...action.update }
  }
  return state
}



// WEBPACK FOOTER //
// ./src/store/backgroundJobs.js